import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Column } from 'primereact/column'
import type { LocalizedText } from '../../../lib/localizedText'
import { InputSwitch } from 'primereact/inputswitch'
import Button from '../../../components/ui/Button'
import Badge from '../../../components/ui/Badge'
import type { City } from '../types'

interface ColumnOpts {
  t: TFunction
  /** Ad kolonu tek kolondur; değer seçili dilden gelir (`lib/localizedText`). */
  localized: LocalizedText
  busyId: number | null
  onEdit: (row: City) => void
  onToggle: (row: City, active: boolean) => void
  onDelete: (row: City) => void
}

/** Şehir tablosunun sütunları (CountryColumns ikizi; seçili ülkeye ait). SORT_INDEX yok → ada göre sıralı + sayfalı. */
export function cityColumns({ t, localized, busyId, onEdit, onToggle, onDelete }: ColumnOpts): ReactElement[] {
  return [
    <Column
      key="name"
      header={t('location.cities.columns.name')}
      body={(row: City) => localized(row.nameTr, row.nameEn)}
    />,
    <Column
      key="status"
      header={t('location.cities.columns.status')}
      style={{ width: '8rem' }}
      body={(row: City) => {
        const active = row.recordStatus === 1
        return (
          <Badge tone={active ? 'green' : 'neutral'}>
            {active ? t('location.cities.status.active') : t('location.cities.status.passive')}
          </Badge>
        )
      }}
    />,
    <Column
      key="actions"
      header={t('location.cities.columns.actions')}
      style={{ width: '10rem' }}
      body={(row: City) => {
        const active = row.recordStatus === 1
        return (
          <div className="admin-row-actions">
            <InputSwitch
              className="admin-switch"
              checked={active}
              disabled={busyId === row.id}
              onChange={(e) => onToggle(row, Boolean(e.value))}
              aria-label={row.nameTr}
              tooltip={t('location.cities.actions.toggle')}
              tooltipOptions={{ position: 'bottom' }}
            />
            <Button
              icon="pi pi-pencil"
              rounded
              text
              aria-label={t('location.cities.actions.edit')}
              tooltip={t('location.cities.actions.edit')}
              tooltipOptions={{ position: 'bottom' }}
              onClick={() => onEdit(row)}
            />
            <Button
              icon="pi pi-trash"
              rounded
              text
              severity="danger"
              aria-label={t('location.cities.actions.delete')}
              tooltip={t('location.cities.actions.delete')}
              tooltipOptions={{ position: 'bottom' }}
              disabled={busyId === row.id}
              onClick={() => onDelete(row)}
            />
          </div>
        )
      }}
    />,
  ]
}
